import axiosInstance from "./AxiosInstance";
import { loginConfirmedAction, Logout } from "../store/actions/AuthActions";
import config from "../config";
import { chatAction } from "../store/actions/ChatActions";
import { msgAction } from "../store/actions/MsgAction";

export function signUp(data) {
  return axiosInstance({
    url: config.routes.register,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  });
}

export function login(username, password) {
  return axiosInstance({
    url: config.routes.login,
    method: "post",
    data: {
      username: username.trim(),
      password: password,
    },
  });
}
export function socialLogin(provider, navigate) {
  window.location.replace(`${config?.appUrl}auth/${provider}`);
  // navigate(`https://meksdev.tainosystems.com/amglobalapi/auth/${provider}`, { replace: true });
  // return axiosInstance({
  //   url: config.routes.socialLogin(provider),
  //   method: "get",
  // });
}

export function logout() {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.logout,
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function forgotPasswordService(email) {
  return axiosInstance({
    url: config.routes.forgotPwd,
    method: "post",
    data: {
      email: email.trim(),
    },
  });
}

export function getLoginData(token) {
  return axiosInstance({
    url: config.routes.getLoginData,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export function loginProfile(url) {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: `${config.routes.login}/${url}`,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
// export function updateWebSocket() {
// 	const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

// 	return axiosInstance({
// 		url: config.routes.updateWebSocket,
// 		method: "get",
// 		params: {
// 			token: token,
// 		},
// 	});
// }

export function saveTokenInStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(new Date().getTime() + 60 * 60 * 1000);
  sessionStorage.setItem("userDetails", JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
  setTimeout(() => {
    dispatch(Logout(navigate, false));
  }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
  const tokenDetailsString = sessionStorage.getItem("userDetails");

  let tokenDetails = "";

  if (!tokenDetailsString) {
    dispatch(Logout(navigate, true));
    return;
  }

  tokenDetails = JSON.parse(tokenDetailsString);
  let expireDate = new Date(tokenDetails.expireDate);
  let todaysDate = new Date();

  if (todaysDate > expireDate) {
    dispatch(msgAction(false));
    dispatch(chatAction(false));
    dispatch(Logout(navigate, false));
    return;
  }

  dispatch(loginConfirmedAction(tokenDetails));

  const timer = expireDate.getTime() - todaysDate.getTime();
  runLogoutTimer(dispatch, timer, navigate);
}
